import { OptionBase } from 'chakra-react-select';

import { OrderEnum } from 'lib/generated/graphql';

export interface SelectOption extends OptionBase {
  text: string;
  value: OrderEnum;
}
export const orderOptions: SelectOption[] = [
  { text: 'Mais recentes', value: OrderEnum.Newer },
  { text: 'Mais antigas', value: OrderEnum.Older },
  { text: 'Maior remuneração', value: OrderEnum.MaxSalary },
  { text: 'Menor remuneração', value: OrderEnum.MinSalary },
];
